var borders_default = {
  "borderT": "pRH2h",
  "borderB": "p11iR",
  "borderL": "Q2kPZ",
  "borderR": "OK84l",
  "borderColorOverride": "_4jNh9"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
